module.exports = __webpack_public_path__ + "static/media/inprogress.56e2497e.svg";